import LOOKER_ACTIONS from '../../../features/lrs/shared/lrsActionsConstant';

const { TRO, LEXILE_EVENT } = LOOKER_ACTIONS;
const {
    AUDIO_PLAYER_EVENT,
    BOOK_RESCORING_EVENT,
    REVERT_EVENT,
    RESCORED_WITH_THIRD_BOOK_EVENT,
    RESCORED_NOT_SCORED_BOOK_EVENT,
} = TRO;

export const troAudioPlayerEvent = () => ({
    type: AUDIO_PLAYER_EVENT,
});

export const troBookRescoringEvent = (eventType, complexityLevel) => ({
    type: BOOK_RESCORING_EVENT,
    eventType,
    complexityLevel,
});

export const troNotScoredBookRescoringEvent = eventType => ({
    type: RESCORED_NOT_SCORED_BOOK_EVENT,
    eventType,
});

export const troRevertEvent = () => ({
    type: REVERT_EVENT,
});

export const troRescoringWithThirdBookEvent = () => ({
    type: RESCORED_WITH_THIRD_BOOK_EVENT,
});

export const lexileLookerEvent = isLexileShown => ({
    type: LEXILE_EVENT,
    isLexileShown,
});
